import { CHROMATIC, shadowTokens } from './tokens';

// ----------------------------------------------------------------------

/**
 * The named shadows (`theme.customShadows.*`) from the Cabinet Base tokens.
 * In dark mode a grey-tinted shadow is invisible against a dark surface, so
 * the tokens cast black there and the opacities carry the depth.
 *
 * @param palette the palette shadows are being generated for; only its mode
 * is read.
 */
export default function customShadows(palette = { mode: 'light' }) {
    const t = shadowTokens(palette.mode);
    return {
        z1: t['shadow-z1'],
        z4: t['shadow-z4'],
        z8: t['shadow-z8'],
        z12: t['shadow-z12'],
        z16: t['shadow-z16'],
        z20: t['shadow-z20'],
        z24: t['shadow-z24'],
        //
        ...Object.fromEntries(
            CHROMATIC.map((color) => [color, t[`shadow-${color}`]])
        ),
        //
        card: t['shadow-card'],
        dialog: t['shadow-dialog'],
        dropdown: t['shadow-dropdown']
    };
}
